import { useSelector } from "react-redux";

import {
  selectAuthLoading,
  selectIsAuthenticated,
  selectProfile,
} from "../../redux/reducers/user/user-Slice";

const PLACEHOLDER_AVATAR = "/assets/images/place-holder-img.svg";

const useUser = () => {
  const profile = useSelector(selectProfile);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const loading = useSelector(selectAuthLoading);

  const displayName =
    profile.fullName?.trim() || profile.firstName?.trim() || "Profile";

  return {
    profile,
    isAuthenticated,
    loading,
    displayName,
    avatarUrl: profile.profileImage || null,
    avatarSrc: profile.profileImage || PLACEHOLDER_AVATAR,
    phoneNumber: profile.phoneNumber || "",
    email: profile.email || "",
  };
};

export default useUser;
